import { makeStyles, Theme } from "@material-ui/core";

export const useCommonStyles = makeStyles((theme: Theme) => ({
    root: {
        flexGrow: 1,
        margin: theme.spacing(0, 16),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 200,
    },
    textField: {
        margin: theme.spacing(1),
        width: "100%",
    },
    successMessage: {
        padding: theme.spacing(2),
        marginTop: theme.spacing(2),
        fontSize: '16px'
    }
}));
